import React,{useState, useEffect, useContext} from 'react';
import { useParams } from 'react-router-dom';
import ReactPlayer from 'react-player';
import { BsFillCheckCircleFill } from 'react-icons/bs';
import { AiOutlineLike } from 'react-icons/ai';
import { abbreviateNumber } from 'js-abbreviation-number';

import { fetchDataFromApi } from '../utils/api';
import { Context } from '../context/contextApi';
import SuggestionVideoCard from './SuggestionVideoCard';

const VideoDetails = () => {

  const [video, setVideo] = useState("");
  const [relatedVideos, setRelatedVideos] = useState([]);
  const {id} = useParams();
  const {setLoading} = useContext(Context);

  useEffect(() => {
    document.getElementById("root").classList.add("custom-h");
    fetchVideoDetails();
    fetchRelatedVideos();
  }, [id]);

  const fetchVideoDetails = () => {
    setLoading(true);
    fetchDataFromApi(`video/details/?id=${id}`)
    .then((response) => {
      setVideo(response);
      setLoading(false);
    })
  }

  const fetchRelatedVideos = () => {
    setLoading(true);
    fetchDataFromApi(`video/related-contents/?id=${id}`)
    .then((response) => {
      setRelatedVideos(response.contents);
      setLoading(false);
    })
  }

  return (
    <div className='flex justify-center md:flex-row flex-col h-[calc(100%-56px)] md:px-10 bg-black'>
      <div className='md:w-[60%] flex flex-col lg:flex-row sticky top-0 md:static bg-black '>
        <div className='flex flex-col lg:w-[100%] px-4 py-3 lg:py-6 overflow-y-auto'>
          <div className='h-[220px] md:h-[420px] ml-[-16px] lg:ml-0 mr-[-16px] lg:mr-0'>
            <ReactPlayer 
                url={`https://www.youtube.com/watch?v=${id}`}
                controls
                width="100%"
                height="100%"
                style={{backgroundColor: "#444"}}
                playing={true}
            />
          </div>
          <div className='text-white font-bold text-sm md:text-xl mt-4 line-clamp-2'>
            {video?.title}
          </div>
          <div className='flex md:items-center  mt-6'>
            <div>
              <img src={video?.author?.avatar[0]?.url} className='w-9 h-9 object-cover mr-4 rounded-full' alt="Channel_Img" />
            </div>
            <div className='flex flex-col md:flex-row justify-between w-[100%]'> 
                <div>
                  <div className='flex items-center font-bold text-white text-[18px]'>
                      {video?.author?.title}
                        {
                          video?.author?.badges[0]?.type === "VERIFIED_CHANNEL" && (
                            <BsFillCheckCircleFill className='text-white/[0.5] ml-1 text-[12px] mt-1' />
                          )
                        }
                  </div>
                  <div className='text-[12px] text-white/[0.6]'>
                    {
                      video?.author?.stats?.subscribersText
                    }
                  </div>
                </div>
                <div className='flex items-center mt-4 md:mt-0 cursor-pointer'>
                  <span className='text-white flex items-center mr-4 rounded-2xl text-sm py-1 px-4 bg-white/[0.2]'>
                    <AiOutlineLike className='mr-2 text-sm' />
                    {
                     `${abbreviateNumber(video?.stats?.likes,2)} Likes`
                    }
                  </span>

                  <span className='text-white rounded-2xl text-sm py-1 px-4 bg-white/[0.2]'>
                    {
                     `${abbreviateNumber(video?.stats?.views,2)} Views`
                    }
                  </span>
                </div>
            </div>
          </div>
        </div>
      </div>
      {/* Suggestion video section */}
      <div className='overflow-y-scroll md:w-[40%] p-4'>
        <h2 className='text-white text-xl'>Related Videos</h2>
        {
          relatedVideos && relatedVideos.map((item, i) => {
            return (
              <SuggestionVideoCard item={item} key={i}/>
            )
          })
        }
      </div>

    </div>
  )
}

export default VideoDetails;
